import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Breadcrumb() {
  const location = useLocation();
  const { pathname } = location;

  const [parameter1, parameter2, parameter3] = pathname
    .split("/")
    .filter(Boolean);

  function capitalizeFirstLetter(string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  useEffect(() => {
    console.log(pathname);
    if (!parameter1) localStorage.setItem("selectedItem", "Master");
    else if (parameter1)
      localStorage.setItem("selectedItem", capitalizeFirstLetter(parameter1));
    else localStorage.setItem("selectedItem", "Master");
  }, [pathname, parameter1]);

  return (
    <div className="bread-container">
      <div className="ui breadcrumb">
        {!parameter1 && <a className="section">Home</a>}
        {!parameter1 && <i className="right chevron icon divider"></i>}
        {parameter1 && <a className="section">{parameter1}</a>}
        {parameter1 && <i className="right chevron icon divider"></i>}
        {parameter2 && <a className="section">{parameter2}</a>}{" "}
        {parameter2 && <i className="right arrow icon divider"></i>}
        {parameter3 && <div className="active section">{parameter3}</div>}
      </div>
    </div>
  );
}

export default Breadcrumb;
